import { render, staticRenderFns } from "./EvolutionNotes.vue?vue&type=template&id=47b73b74&scoped=true&"
import script from "./EvolutionNotes.vue?vue&type=script&lang=js&"
export * from "./EvolutionNotes.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionNotes.vue?vue&type=style&index=0&id=47b73b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b73b74",
  null
  
)

export default component.exports